module.exports = __webpack_public_path__ + "img/checkbox-checked.e66b994.png";